import { TFunction } from "i18next";
import { RetentionConflict } from "@dashboard-v3/api";

export function formatDays(value: number | null | undefined, t: TFunction) {
  return value == null
    ? t("retentionConflictModal.days.never")
    : t("retentionConflictModal.days.count", { count: value });
}

export function getConflictRoute({ type, id }: RetentionConflict) {
  switch (type) {
    case "rule":
      return `/rules/${id}/edit`;
    case "securityPolicy":
      return `/security-policies/edit/${id}`;
    case "securityDefinition":
      return "/security-definitions";
  }
}

export function getLinkSecurityRoute({
  type,
  id,
}: NonNullable<RetentionConflict["linkSecurity"]>) {
  return type === "securityPolicy"
    ? `/security-policies/edit/${id}`
    : "/security-definitions";
}
